import { render } from "./subsidies.vue?vue&type=template&id=2eff5479&scoped=true"
import script from "./subsidies.vue?vue&type=script&lang=js"
export * from "./subsidies.vue?vue&type=script&lang=js"

import "./subsidies.vue?vue&type=style&index=0&id=2eff5479&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eff5479"]])

export default __exports__